import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=ad0cbd26&"
import script from "./OrdersReport.vue?vue&type=script&lang=js&"
export * from "./OrdersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports